var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:"modalRef",attrs:{"hide-footer":"","size":"lg","title":"Information"}},[_c('ul',_vm._l((_vm.data),function(item,index){return _c('li',{key:index},[_vm._v("\n      £"+_vm._s(item.amount)+" -> "+_vm._s(item.location)+"\n    ")])}),0),_vm._v(" "),_c('b-button',{attrs:{"variant":"danger"},on:{"click":_vm.hide}},[_vm._v("Close")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }